/**
 * Sets a cookie.
 */
function setCookie(name, value, days) {
  let expires = '';

  if (days) {
    const date = new Date();
    date.setTime(
      date.getTime() + (days * 24 * 60 * 60 * 1000)
    );
    expires = `; expires=${date.toUTCString()}`;
  }

  document.cookie =
    `${encodeURIComponent(name)}=${encodeURIComponent(value)}` +
    `${expires}; path=/; SameSite=None; Secure`;
}

/**
 * Gets a cookie value, if it exists.
 */
function getCookie(name) {
  const cookieString = `; ${document.cookie}`;
  const cookies = cookieString.split(
    `; ${encodeURIComponent(name)}=`
  );

  if (cookies.length === 2) {
    return cookies.pop().split(';').shift();
  }

  return null;
}

/* global Modal, Shopify, theme */

if (!customElements.get('pop-up')) {
  customElements.whenDefined('modal-dialog').then(() => {
    class PopUp extends Modal {
      constructor() {
        super();

        this.cookie = `${this.id}-dismissed`;

        const newsletterSuccess = this.querySelector(
          '[data-ard-newsletter-success]'
        );

        if (newsletterSuccess) {
          this.classList.add('ard-newsletter-complete');

          // Remember the signup without requiring the visitor
          // to close the confirmation. Do not set cookies
          // while editing the theme.
          if (!Shopify.designMode) {
            setCookie(this.cookie, true, 400);
          }

          const dialog = this.querySelector('[role="dialog"]');

          if (dialog) {
            dialog.removeAttribute('aria-labelledby');
            dialog.setAttribute(
              'aria-label',
              'Your newsletter discount'
            );
          }

          const copyButton = newsletterSuccess.querySelector(
            '[data-ard-copy-code]'
          );

          const copyStatus = newsletterSuccess.querySelector(
            '[data-ard-copy-status]'
          );

          if (copyButton && copyStatus) {
            copyButton.addEventListener('click', async () => {
              try {
                await navigator.clipboard.writeText('ARDNEWS');
                copyStatus.textContent = 'Copied!';
              } catch (error) {
                copyStatus.textContent =
                  'Please select and copy ARDNEWS manually.';
              }
            });
          }
        }

        if (Shopify.designMode) {
          document.addEventListener(
            'shopify:section:select',
            (evt) => {
              if (
                evt.target === this.closest('.shopify-section')
              ) {
                this.open();
              }
            }
          );

          document.addEventListener(
            'shopify:section:deselect',
            this.close.bind(this)
          );
        } else if (newsletterSuccess) {
          // Still show the code for this successful submission,
          // even though the dismissal cookie has now been set.
          this.open();
          newsletterSuccess.focus();
        } else if (
          !getCookie(this.cookie) &&
          (
            this.dataset.showOnMobile === 'true' ||
            theme.mediaMatches.md
          )
        ) {
          if (this.querySelector('.alert')) {
            this.open();
          } else if (this.dataset.trigger === 'delay') {
            setTimeout(
              () => this.open(),
              Number(this.dataset.delay) * 1000
            );
          } else if (
            this.dataset.trigger === 'exit' &&
            theme.mediaMatches.md
          ) {
            this.mouseLeaveHandler =
              this.mouseLeaveHandler ||
              this.handleMouseLeave.bind(this);

            document.body.addEventListener(
              'mouseleave',
              this.mouseLeaveHandler
            );
          } else if (this.dataset.trigger === 'clipboard') {
            this.copyHandler =
              this.copyHandler ||
              this.handleCopy.bind(this);

            document.addEventListener(
              'copy',
              this.copyHandler
            );
          }
        }
      }

      disconnectedCallback() {
        if (this.mouseLeaveHandler) {
          document.body.removeEventListener(
            'mouseleave',
            this.mouseLeaveHandler
          );
        }

        if (this.copyHandler) {
          document.removeEventListener(
            'copy',
            this.copyHandler
          );
        }
      }

      handleMouseLeave(evt) {
        if (evt.clientY < 0 && !getCookie(this.cookie)) {
          this.open();
        }
      }

      handleCopy() {
        if (!getCookie(this.cookie)) {
          this.open();
        }
      }

      close() {
        super.close();

        if (Shopify.designMode) {
          return;
        }

        // Keep successful signups dismissed for 400 days.
        // Other popups retain their configured dismissal period.
        const days = this.querySelector(
          '[data-ard-newsletter-success]'
        )
          ? 400
          : Number(this.dataset.dismissDays) || 400;

        setCookie(this.cookie, true, days);
      }
    }

    customElements.define('pop-up', PopUp);
  });
}
